import { render } from "./MultiChoiceStats.vue?vue&type=template&id=35931054&scoped=true&ts=true"
import script from "./MultiChoiceStats.vue?vue&type=script&lang=ts"
export * from "./MultiChoiceStats.vue?vue&type=script&lang=ts"

import "./MultiChoiceStats.vue?vue&type=style&index=0&id=35931054&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35931054"]])

export default __exports__